module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chargeDetail1"
    }
  }, [_c('p', {
    staticClass: "chargeDetai_p1"
  }, [_vm._v("收费详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "infomation1"
  }, [_c('div', {
    staticClass: "Headpic"
  }, [_c('img', {
    attrs: {
      "src": _vm.patientBaseEntity.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name1"
  }, [_vm._v(_vm._s(_vm.patientBaseEntity.name))]), _vm._v(" "), _c('div', {
    staticClass: "in-table1"
  }, [_c('div', {
    staticClass: "in-tabOne1"
  }, [_c('h2', [_vm._v("性别:"), _c('span', [_vm._v(_vm._s(this.patientBaseEntity.gender))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tabTow1"
  }, [_c('h2', [_vm._v("周岁:"), _c('span', [_vm._v(_vm._s(_vm.patientBaseEntity.age))])])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel1"
  }, [_c('h2', [_vm._v("电       话:"), _c('span', [_vm._v(_vm._s(this.patientBaseEntity.mobileNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel1"
  }, [_c('h2', [_vm._v("订单编号:"), _c('span', [_vm._v(_vm._s(this.Data))])])])]), _vm._v(" "), _c('div', {
    staticClass: "list1"
  }, [_c('p', {
    staticClass: "list_p1"
  }, [_vm._v("收费信息")]), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tablevalue,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "recipeName",
      "label": "名 称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "数 量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalCost",
      "label": "合 计",
      "width": "200"
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "heji1"
  }, [_vm._v("费用总合计："), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.totalCost ? _vm.totalCost : '0.00') + " 元")]), _vm._v("\n                  " + _vm._s(_vm.gift ? '赠送额度' + _vm.gift + '元' : '') + "\n                ")]), _vm._v(" "), (this.orderType == 0 && !_vm.lookid) ? _c('div', {
    staticClass: "dizhik"
  }, [_c('span', {
    staticStyle: {
      "color": "dimgray"
    }
  }, [_vm._v("是否邮寄药品（不邮寄不用选）：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.levelSelected),
      callback: function($$v) {
        _vm.levelSelected = $$v
      },
      expression: "levelSelected"
    }
  }, _vm._l((_vm.userLevelType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.levelSelected == '是'),
      expression: "levelSelected=='是'"
    }],
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "rows": 2,
      "placeholder": "请输入邮寄地址"
    },
    model: {
      value: (_vm.mailAddress),
      callback: function($$v) {
        _vm.mailAddress = $$v
      },
      expression: "mailAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isPayer) ? _c('div', {
    staticClass: "dizhik"
  }, [_vm._v(" 姓   名：\n                "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.Jname),
      callback: function($$v) {
        _vm.Jname = $$v
      },
      expression: "Jname"
    }
  }, [_vm._l((_vm.options), function(item) {
    return (item.isStock === '1') ? _c('el-option', {
      key: item.index,
      attrs: {
        "label": item.overdraw ? item.name + ' 预存透支:' + item.overdraw : item.name + ' 预存额度:' + item.quota,
        "value": item.id + '@' + item.quota
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.options), function(item) {
    return (item.isStock !== '1') ? _c('el-option', {
      key: item.index,
      attrs: {
        "label": item.overdraw ? item.name + ' 额度透支:' + item.overdraw : item.name + ' 充值额度:' + item.quota,
        "value": item.id + '@' + item.quota
      }
    }) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.mailAddress != '') ? _c('div', {
    staticClass: "dizhik",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.68)"
    }
  }, [_vm._v("\n                邮寄地址：" + _vm._s(_vm.mailAddress) + "\n            ")]) : _vm._e(), _vm._v(" "), (this.$route.query.data) ? _c('div', {
    staticClass: "button1"
  }, [(!_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pay(_vm.paymentType = 0)
      }
    }
  }, [_vm._v("现金支付")]) : _vm._e(), _vm._v(" "), (!_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pay(_vm.paymentType = 2)
      }
    }
  }, [_vm._v("医保卡")]) : _vm._e(), _vm._v(" "), (!_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pay(_vm.paymentType = 3)
      }
    }
  }, [_vm._v("银行卡")]) : _vm._e(), _vm._v(" "), (!_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.change()
      }
    }
  }, [_vm._v("余额支付")]) : _vm._e(), _vm._v(" "), (_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.pay(_vm.paymentType = 4)
      }
    }
  }, [_vm._v("确认余额支付")]) : _vm._e(), _vm._v(" "), (_vm.isPayer) ? _c('el-button', {
    attrs: {
      "type": "plain"
    },
    on: {
      "click": function($event) {
        return _vm.change()
      }
    }
  }, [_vm._v("取消余额支付")]) : _vm._e(), _vm._v(" "), (!_vm.isPayer) ? _c('router-link', {
    attrs: {
      "to": "./charge_list"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    注：如需微信支付，请指导患者在公众号打开“我的订单->待支付订单”查看并支付！\n                ")])], 1) : _vm._e(), _vm._v(" "), (this.$route.query.Data) ? _c('div', {
    staticClass: "button1"
  }, [_c('router-link', {
    attrs: {
      "to": "./charge_list"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    }
  }, [_vm._v("返回")])], 1)], 1) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ac93974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/charge/chargeDetail.vue
// module id = 1001
// module chunks = 2